import { message as $message } from 'antd'
import encUtf8 from 'crypto-js/enc-utf8'
import AES from 'crypto-js/aes'
import ECB from 'crypto-js/mode-ecb'
import Pkcs7 from 'crypto-js/pad-pkcs7'
import MD5 from 'crypto-js/md5'
import { Base64 } from 'js-base64'
import { getPasswordEncodeKey } from '@/services/captcha'

// 密码加密
export const encodePassword = async ({ loginName, password, isBase64 }) => {
    if (isBase64) {
        return Base64.encode(password)
    }
    const { success, message, data } = await getPasswordEncodeKey({ username: loginName })
    if (success) {
        const encodeKey = encUtf8.parse(data)

        const encryptedData = AES.encrypt(password, encodeKey, {
            mode: ECB,
            padding: Pkcs7
        })

        return encryptedData.ciphertext.toString()
    } else {
        $message.error(message)
    }

    return Promise.reject(new Error('加密失败'))
}

// 配置文件字符串+商品名称+款号  md5加密
export const encodeGoodsItem = ({ itemName, styleCode }) => {
    return MD5(PROJECT_CONFIG.goodsEncodeKey + String(itemName).trim() + String(styleCode).trim()).toString()
}
